var React = require('react');

function Left (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M96.53,46.53A3.47,3.47,0,1,1,93.06,50,3.47,3.47,0,0,1,96.53,46.53Z","key":0}),React.createElement("path",{"d":"M73.76,53.47H13.29l23,23-4.91,4.91L0,50,31.38,18.62l4.91,4.91-23,23H73.76Z","key":1})]);
}

Left.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Left;

Left.default = Left;
